import { useEffect, useRef } from "react";

const useClickOutside = (ref, callback) => {
  // store latest callback in a ref so event listener always calls the latest one
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const handleMouseDownOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callbackRef.current?.();
      }
    };
    document.addEventListener("mousedown", handleMouseDownOutside);
    return () => {
      document.removeEventListener("mousedown", handleMouseDownOutside);
    };
  }, [ref]);
};

export default useClickOutside;
